import {zip} from 'underscore';

import {Range} from 'notebook/tables/excess/FunctionConstants';
import {NotApplicableError} from 'notebook/tables/excess/Util';
import {EvaluablePrimitive} from 'notebook/tables/typed-values/DataTypes';
import {NumericCartesianPoint} from 'ui-library/charting/Types';

/**
 * Converts two ranges of x and y values (formatted like Excel functions usually do) into cartesian points,
 * filtering out any invalid non-numeric points.
 */
export default function toCartesianPoints(
  ys: Range<EvaluablePrimitive>,
  xs: Range<EvaluablePrimitive>
): Array<NumericCartesianPoint> {
  const xValues = xs.flat(Infinity);
  const yValues = ys.flat(Infinity);
  if (yValues.length !== xValues.length) {
    throw new NotApplicableError("Unequal lengths of known_y's and known_x's");
  }
  return (zip(xValues, yValues) as Array<[x: EvaluablePrimitive, y: EvaluablePrimitive]>)
    .filter((point): point is [x: number, y: number] => point.every((value) => typeof value === 'number'))
    .map(([x, y]) => ({x, y}));
}
